<div>
    <button (click)="openHotglueWidget()">
      <span>Open specific source</span>
    </button>
    <div id="hotglue-widget-container"></div>
  </div>


